import { ApiCompanyProfessionals } from '@/types/api';
import { Check, Star, Users } from 'lucide-react';

interface ProfessionalCardProps {
  professional?: ApiCompanyProfessionals;
  isAny?: boolean;
  selected: boolean;
  onSelect: (id: string) => void;
}

const ProfessionalCard = ({ professional, isAny, selected, onSelect }: ProfessionalCardProps) => {
  const id = isAny ? 'any' : professional!.id;

  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={() => onSelect(id)}
      className={`flex w-full items-center gap-4 rounded-xl border-2 p-4 transition-all duration-150 ${
        selected
          ? 'border-primary bg-primary-light ring-primary/20 shadow-md ring-1'
          : 'border-border bg-card hover:border-primary/30 hover:shadow-sm'
      } `}
    >
      {isAny ? (
        <div className="bg-muted flex h-14 w-14 shrink-0 items-center justify-center rounded-full">
          <Users className="text-muted-foreground h-6 w-6" />
        </div>
      ) : (
        <img
          src={professional!.photo ?? '/person-placeholder.jpg'}
          alt={professional!.name}
          className="h-14 w-14 shrink-0 rounded-full object-cover"
        />
      )}

      <div className="min-w-0 flex-1 text-left">
        <h4 className="text-card-foreground text-base font-semibold wrap-anywhere">
          {isAny ? 'Qualquer profissional' : professional!.name}
        </h4>
        {isAny ? (
          <p className="text-muted-foreground mt-0.5 text-sm">Primeiro horário disponível</p>
        ) : (
          <>
            {/* <p className="mt-0.5 text-sm text-muted-foreground">{professional!.role}</p> */}
            <div className="mt-1 flex items-center gap-1">
              <Star className="fill-warning text-warning h-3.5 w-3.5" />
              <span className="text-card-foreground text-sm font-medium">{professional!.rating}</span>
              <span className="text-muted-foreground text-xs">({professional!.feedbackCount})</span>
            </div>
          </>
        )}
      </div>

      <div
        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-all ${selected ? 'border-primary bg-primary' : 'border-border'}`}
      >
        {selected && <Check className="text-primary-foreground h-3.5 w-3.5" />}
      </div>
    </button>
  );
};

export default ProfessionalCard;
